import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormControl, FormGroup, FormBuilder, FormArray, Validators} from '@angular/forms';
import {ToastrService} from "ngx-toastr";
import {MatStep} from "@angular/material/stepper";
import {ConsentService} from "../service/consent.service";
import {LoginService} from "../service/login.service";

@Component({
  selector: 'app-consentement',
  templateUrl: './consentement.component.html',
  styleUrls: ['./consentement.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConsentementComponent implements OnInit {

  onboardingType = '';
  textConfig: any = {};
  inputPerRow = 3;
  rowCount = 0;
  consentForm: FormGroup;
  confirmForm: FormGroup;
  formTemplateArray: any = [];
  state = 'loading';
  group = '';
  idEmitter = '';
  formData: any = [];
  @ViewChild('firstStep', { static: false }) firstStep: MatStep | undefined;
  @ViewChild('secondStep', { static: false }) secondStep: MatStep | undefined;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private consentService: ConsentService,
    private loginService: LoginService
  ) {
    this.consentForm = new FormGroup({});
    this.confirmForm = new FormGroup({
      consent: new FormControl(null, [Validators.requiredTrue]),
    });
  }

  orderAsc(arrayItemA: any, arrayItemB: any) {
    if (parseInt(arrayItemA.order) < parseInt(arrayItemB.order)) {
      return -1;
    }
    if (parseInt(arrayItemA.order) > parseInt(arrayItemB.order)) {
      return 1;
    }
    return 0;
  }

  accept() {
    //Test if checkbox is valid
    if (this.confirmForm.get('consent')?.value != true) {
      return;
    }

    let data = [];
    for (let i = 0; i < this.information.length; i++) {
      const control = this.information.controls[i];
      data.push({
        key: this.formData[i].name,
        value: control.value.trim(),
      });
    }

    this.consentService.submitConsent(data, this.group)
      .subscribe({
        next: () => {
          this.toastr.success('Consenti avec succès');
          // @ts-ignore
          this.firstStep?.editable = false;
          // @ts-ignore
          this.secondStep?.editable = false;
        },
        error: () => {
          this.toastr.error('Echec du consentement');
          this.router.navigate(['/error']);
        }
      });
  }

  extractOptions(source: string) {
    return source.split('|');
  }

  updateDataFromCurrentUser() {
    const user = sessionStorage.getItem('currentUser');
    if (user) {
      const data = JSON.parse(user);
      for (let i = 0; i < this.information.length; i++) {
        const control = this.information.controls[i];
        if (data[this.formData[i].name]) {
          control.setValue(data[this.formData[i].name]);
        }
      }
    }
  }

  decodeUrl() {
    this.consentService.getFormConfigObservable().subscribe( (response: any) => {
      const consentControls: FormControl[] = [];
      console.log(response);
      this.formData = response['config'];
      this.textConfig = response['textConfig'];
      this.formData.sort(this.orderAsc);

      for (let field of this.formData) {
        const formControl = new FormControl('');
        if (field.value != '') {
          formControl.setValue(field.value);
        }
        if (!JSON.parse(field.editable)) {
          formControl.disable();
        }
        if (JSON.parse(field.required)) {
          formControl.addValidators(Validators.required);
        }
        if (field.pattern != '') {
          formControl.addValidators(Validators.pattern(field.pattern));
        }
        consentControls.push(formControl);
      }

      this.consentForm.addControl('information', this.formBuilder.array(consentControls));
      this.rowCount = Math.ceil(this.information.controls.length / this.inputPerRow);

      let indexCounter = 0;
      for (let i = 0; i < this.rowCount; i++) {
        const rowArray: any = [];
        let j = 0;
        while (j < this.inputPerRow && indexCounter < this.information.controls.length) {
          rowArray.push(this.information.controls[indexCounter]);
          j++;
          indexCounter++;
        }
        this.formTemplateArray.push(rowArray);
      }

      this.state = 'loaded';
      this.group = this.loginService.getGroup();
      this.updateDataFromCurrentUser();
    });
  }

  get information(): FormArray {
    return <FormArray> this.consentForm.get('information');
  }

  ngOnInit() {
    this.decodeUrl();
  }
}
